// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_CarregaClientesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/carrega_clientes
 *
 * Returns XCRUD-formatted client list for the current user's franchises.
 */
import type { Clientes_CarregaClientesRow } from './Clientes_CarregaClientesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Clientes_CarregaClientesResponseDados = Clientes_CarregaClientesRow[];

export type Clientes_CarregaClientesResponse = ApiResponse<Clientes_CarregaClientesResponseDados>;

registerResponseContract('Clientes_CarregaClientesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:            { type: 'number',  required: true },
      acoes:                 { type: 'number',  required: true },
      nome:                  { type: 'string',  required: true },
      documento:             { type: 'string',  required: false },
      documento_tipo:        { type: 'string',  required: false },
      ddi:                   { type: 'string',  required: false },
      ddd:                   { type: 'string',  required: false },
      telefone:              { type: 'string',  required: false },
      telefone_completo:     { type: 'string',  required: false },
      email:                 { type: 'string',  required: false },
      endereco_completo:     { type: 'string',  required: false },
      franquia_id:           { type: 'number',  required: true },
      rua:                   { type: 'string',  required: false },
      cep:                   { type: 'string',  required: false },
      numero:                { type: 'string',  required: false },
      complemento:           { type: 'string',  required: false },
      bairro:                { type: 'string',  required: false },
      cliente_location_id:   { type: 'number',  required: false },
      cliente_location_type: { type: 'string',  required: false },
      data_cadastro:         { type: 'string',  required: false },
      status:                { type: 'number',  required: false },
      status_label:          { type: 'string',  required: false },
      origem_id:             { type: 'number',  required: false },
      origem_nome:           { type: 'string',  required: false },
      franquia:              { type: 'string',  required: false },
      localidade:            { type: 'string',  required: false },
      orcamentos: {
        type: 'array',
        required: false,
        items: {
          orcamento_id:            { type: 'number',  required: true },
          orcamento_franquia_id:   { type: 'number',  required: true },
          orcamento_user_id:       { type: 'string',  required: true },
          orcamento_location_id:   { type: 'number',  required: false },
          orcamento_location_type: { type: 'string',  required: false },
          orcamento_valor:         { type: 'number',  required: true },
          orcamento_origem:        { type: 'number',  required: false },
          orcamento_data:          { type: 'string',  required: true },
          orcamento_status:        { type: 'string',  required: true },
          status_label:            { type: 'string',  required: true },
          orcamento_observacao:    { type: 'string',  required: false },
          orcamento_cliente_id:    { type: 'number',  required: false },
          franquia_nome:           { type: 'string',  required: false },
          Localidade:              { type: 'string',  required: false },
        },
      },
      qtdOrcamentos:         { type: 'string',  required: false },
    },
  },
})
